import React from 'react';
import { styled } from 'baseui';
import { LabelSmall } from 'baseui/typography';
import { ANNOTATION_TYPE } from '../../image/labelling/constants';
import AnnotationLabelSelector from '../annotation-label-selector/annotation-label-selector';
import Divider from '../divider/divider';
import type { AnnotationLabelT, GenericAnnotationT, GetAnnotationMetaDetailsT } from '../types/types';
const HeadingContainer = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column'
}));
const ElementRow = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale400,
  paddingBottom: '8px'
}));
const ID = styled('div', ({
  $theme
}) => ({
  fontSize: '12px',
  textDecoration: 'capitalize',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginTop: `-${$theme.sizing.scale300}`,
  marginLeft: `calc(${$theme.sizing.scale1200} - 4px)`,
  color: $theme.colors.primary,
  width: 'inherit'
}));
type PropsT = {
  onAnnotationUpdate: (a: AnnotationLabelT) => void;
  annotationLabels: AnnotationLabelT[];
  annotation: GenericAnnotationT;
  editableAnnotationId: string;
  checkLabelMaxReached: (annotationLabel: AnnotationLabelT) => boolean;
  getAnnotationMetaDetails: GetAnnotationMetaDetailsT;
  allowedAnnotationLabels?: AnnotationLabelT[];
  getAnnotationDataDetail?: () => React.ReactNode;
};
const AnnotationEditor = ({
  onAnnotationUpdate,
  annotationLabels,
  annotation,
  editableAnnotationId,
  checkLabelMaxReached,
  getAnnotationMetaDetails,
  allowedAnnotationLabels,
  getAnnotationDataDetail
}: PropsT) => {
  // @ts-expect-error todo(ts-migration) TS2339 Property 'icon' does not exist on type 'GetAnnotationMetaDetailsReturnT'.
  const {
    icon
  } = getAnnotationMetaDetails({
    annotationId: editableAnnotationId
  });
  const isReadOnly = annotation.annotationType === ANNOTATION_TYPE.SEGMENTATION;
  return <HeadingContainer>
      <ID>{editableAnnotationId}</ID>
      <Divider />
      <ElementRow>
        <LabelSmall>Label:</LabelSmall>
        <AnnotationLabelSelector selectedLabel={annotation.annotationLabel} annotationLabels={annotationLabels} checkLabelMaxReached={annotationLabel => {
        if (annotationLabel.title === annotation.annotationLabel.title) return false;
        return checkLabelMaxReached(annotationLabel);
      }} onChange={onAnnotationUpdate} readOnly={isReadOnly} allowedAnnotationLabels={allowedAnnotationLabels} />
      </ElementRow>
      <ElementRow>
        <LabelSmall>Type:</LabelSmall>
        {icon}
      </ElementRow>
      {getAnnotationDataDetail ? <ElementRow>{getAnnotationDataDetail()}</ElementRow> : null}
    </HeadingContainer>;
};
export default AnnotationEditor;